import { useEffect } from 'react'

import { publishEvent } from '@zet/analytics'
import { Stack } from '@zet/design-system/layout'
import { useUserContext } from '@zet/feature-user'

import ArnTrackApplication from './arnTrackApplication'
import ARNFAQs from './faqs'

// TODO: Add types
interface HdfcArnPops {
  item: object
  brandComms: object
  ask: object
}

const HdfcArn: React.FC<HdfcArnPops> = (props) => {
  const { item, brandComms, ask } = props
  const { data: user } = useUserContext()
  const askCode = ask?.askCode

  useEffect(() => {
    publishEvent('screen_view', {
      screen_name: 'LeadProgress',
      page_name: askCode,
      partner_id: item?.partnerId,
      brand_name: brandComms?.name,
      lead_id: item?.id,
      user_id: user.id,
      customer_id: item?.customerId,
      arn: item?.referenceId,
    })
  }, [])

  return (
    <Stack className=" bg-neutral-white100">
      <ArnTrackApplication
        item={item}
        askCode={askCode}
        ask={ask}
        brandName={brandComms?.name}
      />
      <ARNFAQs brandComms={brandComms} item={item} askCode={askCode} />
    </Stack>
  )
}

export default HdfcArn
